import { ProtectedRoutes, PublicRoutes } from "@sg-protect/federation-runtime/squide";
import config from "@sg-protect/runtime-config";
import type { ModuleRegisterFunction } from "./moduleRegisterFunction.ts";
import { ConnectedRootErrorBoundary } from "./RootErrorBoundary.tsx";
import { RootLayout } from "./RootLayout.tsx";

export const registerAppShell: ModuleRegisterFunction = runtime => {
    registerReferrer();

    runtime.registerRoute(
        {
            element: <RootLayout />,
            children: [
                {
                    $id: "root-error-boundary",
                    errorElement: <ConnectedRootErrorBoundary />,
                    children: [PublicRoutes, ProtectedRoutes]
                }
            ]
        },
        { hoist: true }
    );

    runtime.registerPublicRoute(
        {
            path: "*",
            lazy: async () => {
                const { NotFoundError } = await import("./layouts/NotFoundError.tsx");

                return { element: <NotFoundError homeUrl={config.get().home.baseUrl} /> };
            }
        },
        {
            parentId: "root-error-boundary"
        }
    );
};

function registerReferrer(search: Location["search"] = window.location.search) {
    const params = new URLSearchParams(search);
    const ref = params.get("referrer");

    if (ref) {
        sessionStorage.setItem("sg-protect-referrer", JSON.stringify(ref));
    }
}
